//导入request.js
import { ajax } from "./ajax";

// 查询定价套餐信息
export const ysySystemMealHome = (params) => ajax("/ysy/systemMeal/home", params, "GET");

// 查询定价套餐信息V2
export const ysySystemMealHomeV2 = (params) => ajax("/ysy/systemMeal/listV2", params, "GET");

// 帮助中心获取模块列表
export const ysyVideoTutorialModule = (params) => ajax("/ysy/video/tutorial/module", params, "POST");

// 帮助中心获取指定模块下的视频列表
export const ysyVideoTutorialList = (params) => ajax("/ysy/video/tutorial/list", params, "POST");

// 下载软件最新版本
export const ysyVersionCurrent = (params) => ajax("/ysy/version/current", params, "POST");

export const ysyUserHelpCenterSearch = (params) => ajax("/ysy/user/help/center/search", params, "POST");

export const ysyHelpCenterList = (params) => ajax("/ysy/user/help/center/list", params, "POST")



// 20260203 改版套餐接口
export const appSystemMealList = (params) => ajax("/ysy/app/systemMeal/list", params, "GET");

// 获取充值配置列表
export const getCloudRechargeConfigApi = (params) => ajax(`/ysy/cloud/asset/recharge/config/list`, params, "POST");